import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, MenuItem } from '@material-ui/core';
import { conditions } from './xPathUtil';

var OperatorSelect = function OperatorSelect(_ref) {
  var value = _ref.value,
      _onChange = _ref.onChange,
      classes = _ref.classes;
  return React.createElement(TextField, {
    fullWidth: true,
    select: true,
    value: value,
    onChange: function onChange(e) {
      return _onChange(e.target.value);
    }
  }, conditions.map(function (condition, index) {
    return condition.Category ? React.createElement(MenuItem, {
      key: index,
      disabled: true,
      value: index,
      style: {
        opacity: 1
      },
      className: classes.operatorGroup
    }, condition.Category) : React.createElement(MenuItem, {
      key: index,
      value: index,
      className: classes.operatorItem
    }, condition.Name);
  }));
};

var styles = function styles(theme) {
  return {
    operatorItem: {
      paddingLeft: theme.spacing(3)
    },
    operatorGroup: {
      color: '#777'
    }
  };
};

export default withStyles(styles, {
  withTheme: true,
  name: 'ECOperatorSelect'
})(OperatorSelect);